import type {
  AccommodationPriceBreakDownItem,
  PriceBreakDownItemType,
} from "~/generated/graphql";
import { CustomerPriceType } from "~/generated/graphql";
import type useGetCartPriceBreakDownItems from "~/clientState/hooks/useGetCartPriceBreakDownItems";

type CartItems = ReturnType<
  typeof useGetCartPriceBreakDownItems
>["cartPriceBreakDownItems"];

const validateCustomerPriceType = (
  item?: object,
): item is AccommodationPriceBreakDownItem =>
  !!item && "selectedCustomerPriceType" in item;

const useHasCustomerSelectedPrimePrice = (
  items: CartItems,
  itemType: PriceBreakDownItemType,
): boolean => {
  if (!items) return false;

  const cartPriceBreakDownItem = items.find(({ type }) => type === itemType);

  if (!validateCustomerPriceType(cartPriceBreakDownItem)) return false;

  return (
    cartPriceBreakDownItem.selectedCustomerPriceType === CustomerPriceType.Prime
  );
};

export default useHasCustomerSelectedPrimePrice;
